export const url = "https://api.gymakofficial.com/";